<template>
	<b-modal 
		id="modal-edit-real" 
		title="Modifier une réservation" 
		centered
		@hide="resetModal"
		@ok="handleOk">
		<b-form ref="form" @submit.stop.prevent="handleSubmit">
			<b-form-group
				id="fieldset-1"
				label-for="calendar-edit-real-adherent_id"
				:invalid-feedback="invalidFeedback('adherent_id')"
				:state="validateState('adherent_id')">
				<b-form-select id="calendar-edit-real-adherent_id" v-model="adherent_id" :state="validateState('adherent_id')" required>
					<b-form-select-option v-bind:value="null">Choisissez un adhérent</b-form-select-option>
                    <b-form-select-option v-for="adherent in adherents" :value="adherent.id" :key="adherent.id">
                        {{adherent.title}} {{adherent.firstname}} {{adherent.lastname}}
                    </b-form-select-option>
				</b-form-select>
			</b-form-group>
		<!--	<b-form-group
				label="Date de début :"
				:invalid-feedback="invalidFeedback('start')"
				:state="validateState('start')">
				<b-form-row>
					<b-col><b-form-input v-model="startDate" type="date" :state="validateState('start')" required/></b-col>
					<b-col><b-form-input v-model="startTime" type="time" :state="validateState('start')" required/></b-col>
				</b-form-row>
			</b-form-group>-->
			<b-form-group
				label="Valeur de début :"
				:invalid-feedback="invalidFeedback('start_val')"
				:state="validateState('start_val')">
				<b-form-row>
					<b-col><b-form-input v-model="start_val" type="number" step="0.01" :state="validateState('start_val')" required/></b-col>
				</b-form-row>
			</b-form-group>
		<!--	<b-form-group
				label="Date de fin :"
				:invalid-feedback="invalidFeedback('end')"
				:state="validateState('end')">
				<b-form-row>
					<b-col><b-form-input v-model="endDate" type="date" :state="validateState('end')" required/></b-col>
					<b-col><b-form-input v-model="endTime" type="time" :state="validateState('end')" required/></b-col>
				</b-form-row>
			</b-form-group>-->
			<b-form-group
				label="Valeur de fin :"
				:invalid-feedback="invalidFeedback('end_val')"
				:state="validateState('end_val')">
				<b-form-row>
					<b-col><b-form-input v-model="end_val" type="number" step="0.01" :state="validateState('end_val')" required/></b-col>
				</b-form-row>
			</b-form-group>
			<b-form-group
				label="Activité (optionnel) :"
				:invalid-feedback="invalidFeedback('activity')"
				:state="validateState('activity')">
				<b-form-input type="text" v-model="activity" placeholder="Activité effectué, précision sur le véhicule..." :state="validateState('activity')"/>
			</b-form-group>
		</b-form>
		<b-alert variant="danger" :show="isServerError">Une erreur inattendue est survenue. Si elle persiste, veuillez contacter Kemtag.</b-alert>
		<template v-slot:modal-footer="{ ok, cancel}">
			<div v-if="!isBusy">
				<b-button size="sm" variant="danger" @click="cancel()">
					Annuler
				</b-button>
				<b-button size="sm" variant="success" @click="ok()" :disabled="hasErrors">
					Modifier
				</b-button>
			</div>
			<b-button  size="sm" variant="success" disabled v-if="isBusy">
				<b-spinner small></b-spinner>
				Modification...
			</b-button>  	
		</template>
	</b-modal>
</template>

<script>
	const date = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
	const time = /([0-1]?\d|2[0-3])(?::([0-5]?\d))?(?::([0-5]?\d))/;
	import { mapGetters } from 'vuex';
	export default {
		name: "CalendarEdit",
		data : ()  => ({
			isBusy: false,
			isServerError: false,
			validation : { 
				adherent_id : {
					$dirty: true,
					$error: false,
					required: false
				},
			/*	start : {
					$dirty: true,
					$error: false,
					required: false,
					date: false,
					time: false,
					before: false
				},
				end : {
					$dirty: true,
					$error: false,
					required: false,
					date: false,
					time: false,
					after: false,
				},*/
				start_val : {
					$dirty: true,
					$error: false,
					required: false,
					date: false,
					time: false,
					before: false
				},
				end_val : {
					$dirty: true,
					$error: false,
					required: false,
					date: false,
					time: false,
					after: false,
				},
				activity : {
					$dirty: false,
					$error: false,
					max: false
				}
			},
			id: null,
			adherent_id: null,
			startDate: "",
			startTime: "",
			endDate: "",
			endTime: "",
			start_val: 0.0,
			end_val: 0.0,
			activity: null,
			options: [
				{ value: null, text: 'Selectionnez un adhérent' },
				{ value: 0, text: 'Bertrand de la Laporte' },
				{ value: 1, text: 'Charles Lambert' },
				{ value: 2, text: 'Capucine Fernandes-Legrand' },
				{ value: 3, text: 'Diane Fernandez' },
				{ value: 4, text: 'Étienne Vaillant-Lagarde' },
				{ value: 5, text: 'Roger Benoit' },
				{ value: 6, text: 'Arthur Goncalves' }
			],
		}),
		mounted() {
			this.$store.dispatch('adherents/getAdherents');
		},
		computed: {
			...mapGetters({
                adherents: 'adherents/adherents',
            }),
	/*		start () {
				return new Date(this.startDate + " " + this.startTime);
			},
			end () {
				return new Date(this.endDate + " " + this.endTime)
			},*/
			hasErrors () {
				return this.validation['adherent_id'].$error 
			//		|| this.validation['start'].$error
			//		|| this.validation['end'].$error
					|| this.validation['activity'].$error
					|| this.validation['start_val'].$error
					|| this.validation['end_val'].$error
			}
		},
		watch: {
			// whenever question changes, this function will run
			'adherent_id': function (newVal, oldVal) {
				if(oldVal == null && !this.validation['adherent_id'].$dirty) {
					this.validation['adherent_id'].$dirty = true
				}
				this.validation['adherent_id'].required = newVal == null
				this.validation['adherent_id'].$error = this.validation['adherent_id'].required
			}, 
			'activity': function (newVal, oldVal) {
				if((oldVal == null || oldVal == '') && !this.validation['activity'].$dirty) {
					this.validation['activity'].$dirty = true
				} else if(newVal == '') {
					this.validation['activity'].$dirty = false
					this.validation['activity'].$error = false
				} else {
					this.validation['activity'].max = newVal.length > 100
					this.validation['activity'].$error = this.validation['activity'].max
				}
			},
			'start_val': function (newVal, oldVal) {
				newVal = newVal*1.0
				oldVal = oldVal*1.0
				this.end_val = this.end_val*1.0
				if((oldVal == null || oldVal == 0) && !this.validation['start_val'].$dirty) {
					this.validation['start_val'].$dirty = true
				} else if((newVal < 0) || (newVal >= this.end_val )) {
					this.validation['start_val'].$error = true
					this.validation['end_val'].$error = true
				} else {
					this.validation['start_val'].$dirty = true
					this.validation['start_val'].$error = false
					this.validation['end_val'].$dirty = true
					this.validation['end_val'].$error = false
				}
			},
			'end_val': function (newVal, oldVal) {
				newVal = newVal*1.0
				oldVal = oldVal*1.0
				this.start_val = this.start_val*1.0
				if((oldVal == null || oldVal == 0) && !this.validation['end_val'].$dirty) {
					this.validation['end_val'].$dirty = true
				} else if((newVal < 0) || (newVal <= this.start_val )) {
					this.validation['start_val'].$error = true
					this.validation['end_val'].$error = true
				} else {
					this.validation['start_val'].$dirty = true
					this.validation['start_val'].$error = false
					this.validation['end_val'].$dirty = true
					this.validation['end_val'].$error = false
				}
			},
		/*	start (newVal) {
				this.validation['start'].required = this.startDate == '' ||  this.startTime == ''
				this.validation['start'].date = date.exec(this.startDate) == null;
				this.validation['start'].time = time.exec(this.startTime) == null;
				this.validation['start'].before = this.start >= this.end
				this.validation['end'].after = this.end <= this.start
				this.validation['end'].$error = this.validation['end'].required
					|| this.validation['end'].after 
					|| this.validation['end'].date
					|| this.validation['end'].time
				this.validation['start'].$error = this.validation['start'].required
					|| this.validation['start'].before 
					|| this.validation['start'].date
					|| this.validation['start'].time
			}, 
			end (newVal) {
				this.validation['end'].required = this.endDate == '' ||  this.endTime == ''
				this.validation['end'].date = date.exec(this.endDate) == null;
				this.validation['end'].time = time.exec(this.endTime) == null;
				this.validation['start'].before = this.start >= this.end
				this.validation['end'].after = this.end <= this.start
				this.validation['end'].$error = this.validation['end'].required
					|| this.validation['end'].after 
					|| this.validation['end'].date
					|| this.validation['end'].time
				this.validation['start'].$error = this.validation['start'].required
					|| this.validation['start'].before 
					|| this.validation['start'].date
					|| this.validation['start'].time
			},*/
			
		},
		methods : {
			validateState(name) {
				const { $dirty, $error } = this.validation[name];
				return $dirty ? !$error : null;
			},
			invalidFeedback(name) {
				var attribute = null;
				switch(name) {
					case 'adherent_id':
						attribute = 'adhérent';
						break;
				/*	case 'start':
						attribute = 'début';
						break;
					case 'end':
						attribute = 'fin';
						break;*/
					case 'start_val':
						attribute = 'début';
						break;
					case 'end_val':
						attribute = 'fin';
						break;
					case 'activity':
						attribute = 'activité';
						break;
				}
			/*	if(this.validation[name].date) {
					return 'La date de ' + attribute + ' ne correspond pas au format YYYY-MM-DD.';
				} else if(this.validation[name].time) {
					return 'L\'heure de ' + attribute + ' ne correspond pas au format HH:mm.';
				} else if(this.validation[name].time) {
					return 'L\'heure de ' + attribute + ' ne correspond pas au format HH:mm.';
				} else*/ if(this.validation[name].required) {
					switch(name) {
						case 'adherent_id':
							attribute = 'L\'adhérent';
							break;
					/*	case 'start':
							attribute = 'La date de début';
							break;
						case 'end':
							attribute = 'La date de fin';
							break;*/
						case 'activity':
							attribute = 'L\'activité';
							break;
						case 'start_val':
							attribute = 'La valeur de '+ attribute;
							break;
						case 'end_val':
							attribute = 'La valeur de '+ attribute;
							break;
					}
					return attribute + ' est obligatoire.'
				} else if(this.validation[name].before) {
					return 'La date de ' + attribute + ' doit être une date antérieure à la date de fin'
				} else if(this.validation[name].after) {
					return 'La date de ' + attribute + ' doit être une date postérieure à la date de début'
				} else if(this.validation[name].max) {
					return 'Le texte de l\'' + attribute + ' ne peut contenir plus de 100 caractères.'
				} 
			},
			show(event) {
				this.isBusy = false;
				this.isServerError = false;
				this.id = event.id
				this.adherent_id = event.adherent_id
				this.activity = event.activity
				//console.log(this.validation);

				this.clearValidation();

				//console.log(this.validation);

				var start = new Date(event.start); 
				this.startDate = start.format("YYYY-MM-DD");
				this.startTime = start.formatTime("HH:mm");

				var end = new Date(event.end);
				this.endDate = end.format("YYYY-MM-DD");
				this.endTime = end.formatTime("HH:mm");
				this.$bvModal.show('modal-edit-real');

				this.start_val = event.start_val;
				this.end_val = event.end_val;
			},
			resetModal(e) {
				// Prevent modal from closing
				
				if(e.trigger != 'ok' && e.trigger != 'event') {
					e.preventDefault();
					this.$bvModal.msgBoxConfirm(
					'Êtes-vous certain de vouloir abandonner vos modifications pour cette réservation ?', 
					{
						title: 'Modification',
						size: 'sm',
						buttonSize: 'sm',
						okVariant: 'danger',
						okTitle: 'Oui',
						cancelTitle: 'Non',
						footerClass: 'p-2',
						hideHeaderClose: true,
						noCloseOnEsc: true,
						noCloseOnBackdrop: true,
						centered: true
					}).then(value => {
						if(value) {
							this.$bvModal.hide('modal-edit-real');
						}
					})
				}
			},
			handleOk(e) {
				// Prevent modal from closing
				e.preventDefault()
				// Trigger submit handler
				this.handleSubmit()
			},
			handleSubmit() {
				if (this.hasErrors) {
					return
				}
				this.$bvModal.msgBoxConfirm('Êtes-vous certain de vouloir modifier cette réservation ?', {
						title: 'Modification',
						size: 'sm',
						buttonSize: 'sm',
						okVariant: 'primary',
						okTitle: 'Confirmer',
						cancelTitle: 'Annuler',
						footerClass: 'p-2',
						hideHeaderClose: true,
						noCloseOnEsc: true,
						noCloseOnBackdrop: true,
						centered: true
					}).then(function(value) {
						if(value) {
							this.isBusy = true;
							this.$store.dispatch('rentals/updateReal', {
								id: this.id,
								adherent_id: this.adherent_id,
								start: this.startDate + " " + this.startTime,
								end: this.endDate + " " + this.endTime,
								start_val: this.start_val,
								end_val: this.end_val,
								status: this.status,
								activity: this.activity
							}).then(() => {
								this.isBusy = false;
								this.$emit('success', this.startDate + " " + this.startTime)
								this.$bvModal.hide('modal-edit-real');
								this.isServerError = false;
							}).catch((error) => {
								this.isServerError = true
								this.isBusy = false
							})
						}
					}.bind(this))
			},
			clearValidation () {
				this.validation = { 
					adherent_id : {
						$dirty: true,
						$error: false,
						required: false
					},
			/*		start : {
						$dirty: true,
						$error: false,
						required: false,
						date: false,
						time: false,
						before: false
					},
					end : {
						$dirty: true,
						$error: false,
						required: false,
						date: false,
						time: false,
						after: false,
					},*/
					start_val : {
						$dirty: true,
						$error: false,
						required: false,
						date: false,
						time: false,
						before: false
					},
					end_val : {
						$dirty: true,
						$error: false,
						required: false,
						date: false,
						time: false,
						after: false,
					},
					activity : {
						$dirty: false,
						$error: false,
						max: false
					}
				}
			}
		}
	}
</script>